import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { DemoInfoPublicRequest } from '@/main/models/request/demoInfoPublicRequest';

export abstract class IHomePagePublicApi {
  abstract registerDemoinfoPublic(
    request: DemoInfoPublicRequest
  ): Promise<AxiosResponse<Result<string>>>;
}

